import { all } from 'redux-saga/effects';

import authSaga from './auth/saga';
import panelCategorySaga from './panelCategory/saga';
import panelSaga from './panel/saga';
import testSaga from './test/saga';
import testCategorySaga from './testCategory/saga';
import layoutSaga from './layout/saga';
import employeeSaga from './employee/saga';
import letterHeadSaga from './letterHead/saga';
import labRegistrationSaga from './labRegistration/saga';
import labMemberShipSaga from './labMemberShip/saga';
import contactPersonSaga from './contactPerson/saga';
import userSaga from './user/saga';
import testRateSaga from './testRateCard/saga';
import panelRateSaga from './panelRateCard/saga';
import discountCouponSaga from './discountCoupon/saga';
import dashboardSaga from './dashboard/saga';
import patientSaga from './patient/saga';
import encounterSaga from './encounter/saga';
import credExpInfoSaga from './credExpInfo/saga';
import notifySaga from './notify/saga';
import reportSaga from './report/saga';
import testParamMappingSaga from './testParamMapping/saga';
import testPanelMappingSaga from './testPanelMapping/saga';
import rangeDefSaga from './rangeDef/saga';
import resultSetSaga from './resultSet/saga';
import UOMSaga from './unitOfMeasurement/saga';
import resetPasswordSaga from './resetPassword/saga';
import observationSaga from './observation/saga';
import designationSaga from './designation/saga';
import associatedListSaga from './associatedList/saga';
import importSaga from './import/saga';
import OPDServiceSaga from './opdServices/saga';
import labSubCenterSaga from './labSubCenter/saga';
import sideBarMenuSaga from './sidebarMenu/saga';
import departmentSaga from './department/saga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        layoutSaga(),
        panelSaga(),
        panelCategorySaga(),
        testSaga(),
        testCategorySaga(),
        employeeSaga(),
        letterHeadSaga(),
        labRegistrationSaga(),
        labMemberShipSaga(),
        contactPersonSaga(),
        userSaga(),
        testRateSaga(),
        panelRateSaga(),
        discountCouponSaga(),
        dashboardSaga(),
        patientSaga(),
        encounterSaga(),
        credExpInfoSaga(),
        notifySaga(),
        reportSaga(),
        testParamMappingSaga(),
        testPanelMappingSaga(),
        rangeDefSaga(),
        resultSetSaga(),
        UOMSaga(),
        resetPasswordSaga(),
        observationSaga(),
        designationSaga(),
        associatedListSaga(),
        importSaga(),
        OPDServiceSaga(),
        labSubCenterSaga(),
        sideBarMenuSaga(),
        departmentSaga(),
    ]);
}
